module.exports = __webpack_public_path__ + "static/media/TJ-Hero.ea183b5e.jpg";